<template>
  <div class="productDetails-box">
    <defaultheader class="topShow" />
    <mobileHeader></mobileHeader>
    <!-- 头部面包屑 -->
    <div class="crumbs-box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{path: '/'}">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-if="!flag" :to="{path: '/product?id=32'}">精品案例</el-breadcrumb-item>
        <el-breadcrumb-item v-for="item in pathList" :key="item.id" :to="{path: item.path}">{{
          item.name
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="productPicture">
      <!-- <el-carousel height="436px">
        <el-carousel-item>
          <img class="imgBox" :src="productObj.articleImg" alt="" />
        </el-carousel-item>
      </el-carousel> -->
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img :src="productObj.articleImg" alt="" />
          </div>
          <!-- <div class="swiper-slide">
            <img :src="productObj.articleImg" alt="" />
          </div> -->
        </div>
      </div>
    </div>
    <div class="productPicture1">
      <img class="imgBox" :src="productObj.articleImg" alt="" />
    </div>
    <div class="biaotiBox">
      <p class="txt1">{{ productObj.articleTitle }}</p>
      <p class="txt2">{{ productObj.articleAbstract }}</p>
      <p class="border1"></p>
    </div>
    <div class="cententBox" v-html="productObj.articleValue"></div>
    <!-- <div class="cententBox">
      <p>
        <span style="color: #555555"><span style="font-family: Source Han Sans">颜色：胡桃色 / 杏色 / 黑色</span></span>
      </p>
      <p>
        <span style="color: #555555"><span style="font-family: Source Han Sans">尺寸：20*130</span></span>
      </p>
      <p>
        <span style="color: #555555"><span style="font-family: Source Han Sans">价格：</span></span
        ><span style="color: #e74c3c"><span style="font-family: Source Han Sans">￥1399.00</span></span>
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>
        <span style="color: #555555"
          ><span style="font-family: Source Han Sans"
            >Arame并不是唯一进行裁剪的地方，即使是一盏灯也能变成一件精工细作的亮眼“衣服”，Arame系列吊灯是艺术家兼设计师设计的新产品，采用了服装设计中常见的手工工艺制作而成。</span
          ></span
        >
      </p>
      <p>&nbsp;</p>
      <p>
        <span style="color: #555555"
          ><span style="font-family: Source Han Sans"
            >吊灯的部分结构由纯手工编织的织物组成，其中包含树脂材料，坚固防火，为了方便，灯罩保持了针织纺织品的外观，但摸上去却会让人感觉坚固耐用。通过创造一种光与影的“编织效果”，为房间营造了一种舒适、富含激情的别致氛围，包裹电线的外皮有多种颜色可供选择：蓝色、红色、黄色、金色、白色和荧光橙色。</span
          ></span
        >
      </p>
      <p>&nbsp;</p>
      <p>
        <span style="color: #555555"
          ><span style="font-family: Source Han Sans"
            >Arame系列吊灯选用了材质，整体结构由条纹纱线包裹而成，是专门的服装实验室特别设计的，纤维呈现规则的几何图案，让人想起了波普艺术，但真正起主导作用的却是实际线条的颜色——蓝色、紫色、红色、黄色，当灯开着的时候，色彩效果和光线混合在一起，创造出多种颜色。</span
          ></span
        >
      </p>
      <p>&nbsp;</p>
    </div> -->
    <div class="redirectBox" v-if="!flag">
      <p @click="articleList[indexFlag - 1] ? toProduct(articleList[indexFlag - 1].id, indexFlag - 1) : ''">
        <i class="el-icon-arrow-left"></i><span>上一个：</span>
        <span v-if="articleList[indexFlag - 1]">{{ articleList[indexFlag - 1].articleTitle }}</span>
        <span v-else> </span>
      </p>
      <p @click="articleList[indexFlag + 1] ? toProduct(articleList[indexFlag + 1].id, indexFlag + 1) : ''">
        <i class="el-icon-arrow-right"></i><span>下一个：</span>
        <span v-if="articleList[indexFlag + 1]">{{ articleList[indexFlag + 1].articleTitle }}</span>
        <span v-else> </span>
      </p>
    </div>
    <div class="relatedProducts" style="display: none">
      <p class="tit">相关产品</p>
      <div class="ctn-box">
        <div class="flBox">
          <div v-for="(item, index) in productObj1" :key="index" @click="toProduct(item.id, index)">
            <img :src="item.articleImg" alt="" />
            <h3>{{ item.articleTitle }}</h3>
          </div>
        </div>
      </div>
    </div>
    <a class="mw-btn" style="display: none" href="javascript:window.history.go(-1);">
      <i class="el-icon-arrow-left"></i>
    </a>
    <defaulfooter />
  </div>
</template>

<script>
import {indexList, articleDetail, articleList, infoList} from '@/api/index'
import mobileHeader from '../components/mobileheader.vue'
import defaultheader from '../components/defaultheader'
import defaulfooter from '@/components/defaulfooter'
import Swiper from 'swiper'
export default {
  components: {
    mobileHeader,
    defaultheader,
    defaulfooter
  },
  // params: {
  //   iid: id || this.$store.state.id
  // },
  name: 'productDetails',
  data() {
    return {
      pathList: [],
      productObj: {}, //文章内容
      productObj1: {}, //更多文章内容
      flag: false, //判断是否从首页进入
      indexFlag: null, //首页文章索引
      articleList: [], //页面数据
      menuIds: null //判断二级菜单id
    }
  },
  created() {
    // console.log('对象', this.ObjectIsNullOrNot01({name: 1}))
    // console.log('这是路由', this.$route)
    // console.log('这是传过来的参数', this.$route.params, this.$route.query)
    if (!this.ObjectIsNullOrNot01(this.$route.query)) {
      if (this.$route.query.flag) {
        this.flag = JSON.parse(this.$route.query.flag)
      }
      if (this.$route.query.menuIds) {
        this.menuIds = this.$route.query.menuIds
      }
      this.indexFlag = Number(this.$route.query.indexFlag)
      this.init(this.$route.query.id)
    } else {
      if (this.$route.params.flag) {
        this.flag = JSON.parse(this.$route.params.flag)
      }
      if (this.$route.params.menuIds) {
        this.menuIds = this.$route.params.menuIds
      }
      this.indexFlag = Number(this.$route.params.indexFlag)
      this.init(this.$route.params.id)
    }
    setTimeout(() => {
      this.swiper()
    }, 1000)
  },
  methods: {
    ObjectIsNullOrNot01(param) {
      //param为一个对象
      return Object.keys(param).length === 0 ? true : false
    },
    //初始化数据
    init(val) {
      if (this.flag) {
        indexList({deptId: 112}).then(res => {
          let query1 = {
            deptId: 112,
            menuIds: res[2].menuIds,
            pageNum: 1,
            pageSize: res[2].articleShowNum
          }
          articleList(query1).then(res => {
            // console.log('文章列表2数据', res)
            this.articleList = res.list
          })
        })
      } else {
        let query1 = {
          deptId: 112,
          menuIds: this.menuIds,
          pageNum: 1,
          pageSize: 10
        }
        articleList(query1).then(res => {
          // console.log('文章列表2数据', res)
          this.articleList = res.list
        })
      }
      articleDetail({articleId: Number(val)}).then(res => {
        // console.log('这是数据', res)
        this.productObj = res
        this.pathList = [{path: '/productDetails', name: this.productObj.articleTitle}]
        //公司基本信息数据
        infoList({deptId: 112}).then(res => {
          document.title = this.productObj.articleTitle + '-' + res.companyName + '-' + res.websiteDesc
        })
        let query = {
          deptId: 112,
          menuIds: this.productObj.menuId,
          pageNum: 1,
          pageSize: 4
        }
        articleList(query).then(res => {
          // console.log('列表数据', res)
          this.productObj1 = res.list
        })
      })
    },
    swiper() {
      var mySwiper = new Swiper('.swiper-container', {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // loop: true,
        // 如果需要滚动条
        scrollbar: '.swiper-scrollbar',
        autoplay: true,
        speed: 1000,
        autoplayDisableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true //设置分页小圆点可手动点击
        }
      })
      // console.log('您的轮播', mySwiper)
      mySwiper.el.onmouseover = function () {
        //鼠标放上暂停轮播
        mySwiper.autoplay.stop()
      }
      mySwiper.el.onmouseleave = function () {
        mySwiper.autoplay.start()
      }
    },
    toProduct(id, num) {
      this.$router.push({
        path: '/blankPage'
      })
      let aaa = {
        id: id,
        indexFlag: num,
        flag: this.flag,
        menuIds: this.menuIds
      }
      localStorage.setItem('detailsObj', JSON.stringify(aaa))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../node_modules/swiper/css/swiper.min.css';
/deep/.swiper-pagination-bullet {
  border-radius: 0 !important;
}
/deep/.swiper-pagination-bullet-active {
  background: #0f0 !important;
}
</style>
